import { ArrowNotification, MainButton, PinkNotification } from "../../../atoms";
import { CardMolecule } from "../../../molecules";
import tokenCoin from "../../../../assets/icons/tokenIcon.png";
import { useContext } from "react";
import { CardContext, SocketContext } from "../../../../context";
import { useTranslation } from "react-i18next";

interface IRenderActionDisplay {
    challengeCard: any;
    isTheUserDilemaOwner: any;
    comfirmActionCardParent: () => void;
}

const RenderActionDisplay: React.FC<IRenderActionDisplay> = ({ challengeCard, isTheUserDilemaOwner, comfirmActionCardParent }) => {
    const { t } = useTranslation();
    const { isActionDoneButtonRevealed } = useContext(SocketContext);
    const { isExchangeButtonOnActionHovered } = useContext(CardContext);
    const isDoneButtonDisabled = !isActionDoneButtonRevealed;

    if (isTheUserDilemaOwner) {
        return (
            <div className="action_card_on_full_screen">
                <div className="position_action_card_on_the_table_wrapper">
                    <div className="challenge_card_animation">
                        {isExchangeButtonOnActionHovered && 
                        <div className="action_card_exchange_button_notification">
                            <PinkNotification notificationWidthVW={35} notificationRenderingSide="right" text={t("exchangeTheActionCardText") } moveFromTop={20} icon={tokenCoin} iconText="-2" />
                        </div>
                        }
                        
                        <CardMolecule card={challengeCard.actionCard!} />
                    </div>
                </div>

                <div className="action_card_on_full_screen_button">
                    <MainButton text={t("doneText")} type="big" clickHandler={() => comfirmActionCardParent()} disabled={isDoneButtonDisabled}/>
                </div>
            </div>
        );
    }

    return (
        <div className="challenge_card_animation">
            <CardMolecule card={challengeCard.actionCard!} />
        </div>
    );

}

export default RenderActionDisplay;